import { useContext } from 'react';
import type {
  DigitalCardActions,
  DigitalCardConfig,
  DigitalCardState,
} from 'src/components/_common/DigitalCard/context';
import {
  DigitalCardActionsContext,
  DigitalCardConfigContext,
  DigitalCardStateContext,
} from 'src/components/_common/DigitalCard/context';

/**
 * 디지털 카드 설정값을 가져오는 훅
 */
export const useDigitalCardConfig = (): DigitalCardConfig => {
  const context = useContext(DigitalCardConfigContext);
  if (!context) {
    throw new Error('useDigitalCardConfig는 DigitalCardProvider 내부에서만 사용할 수 있습니다.');
  }
  return context;
};

/**
 * 디지털 카드 상태를 가져오는 훅
 */
export const useDigitalCardState = (): DigitalCardState => {
  const context = useContext(DigitalCardStateContext);
  if (!context) {
    throw new Error('useDigitalCardState는 DigitalCardProvider 내부에서만 사용할 수 있습니다.');
  }
  return context;
};

/**
 * 디지털 카드 액션을 가져오는 훅
 */
export const useDigitalCardActions = (): DigitalCardActions => {
  const context = useContext(DigitalCardActionsContext);
  if (!context) {
    throw new Error('useDigitalCardActions는 DigitalCardProvider 내부에서만 사용할 수 있습니다.');
  }
  return context;
};

/**
 * 디지털 카드의 모든 Context를 한번에 가져오는 훅
 */
export const useDigitalCard = (): {
  config: DigitalCardConfig;
  state: DigitalCardState;
  actions: DigitalCardActions;
} => {
  const config = useDigitalCardConfig();
  const state = useDigitalCardState();
  const actions = useDigitalCardActions();

  return {
    config,
    state,
    actions,
  };
};
